import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

/**
 * Estado inicial del slice de candidato.
 *
 * @property {boolean} reload      Indica si la vista debe recargarse. Se alterna con cada refresh().
 * @property {?number} candidateId ID del candidato seleccionado. Puede ser null si no hay uno cargado.
 * @property {object} candidate    Información detallada del candidato cargado.
 */
const initialState = {
	reload: true,
	candidateId: null,
	candidate: {},
	reloadFile: true,
}

const CandidateSlice = createSlice({
	name: "candidate",
	initialState,
	reducers: {
		
		refresh(state) {
			state.reload = !state.reload
		},
		
		refreshFile(state) {
			state.reloadFile = !state.reloadFile
		},

		setCandidate(state, action) {
			state.candidate = action.payload
		},

		setCandidateId(state, action) {
			state.candidateId = action.payload
		},
	},
})

export default CandidateSlice

/**
 * Hook que retorna el estado del slice `candidate` desde Redux.
 *
 * @returns {{
 *   reload: boolean,
 *   reloadFile: boolean,
 *   candidateId: (number|null),
 *   candidate: object
 * }}
 *
 * @example
 * const { reload, candidateId, candidate } = useReduxCandidate();
 */
export const useCandidateRedux = () => {
	return useSelector((state) => state.candidate)
}